import { render, staticRenderFns } from "./feedbackType.vue?vue&type=template&id=1d0691dc&scoped=true"
import script from "./feedbackType.vue?vue&type=script&lang=js"
export * from "./feedbackType.vue?vue&type=script&lang=js"
import style0 from "./feedbackType.vue?vue&type=style&index=0&id=1d0691dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0691dc",
  null
  
)

export default component.exports